define(['jquery', 'common', 'pricehelper', 'booking_rules', 'responsive_common', 'scrollto'], function ($, ERVCommon, ERVPriceHelper, ERVBookingRules, ERVResponsiveCommon) {

		var ProductHelper = function() {
			var self = this;
			self.$ervBody = $('#erv-body');
			self.priceHelper = new ERVPriceHelper();
			self.bookingRules = new ERVBookingRules();
			self.common = new ERVCommon();
			self.responsiveCommon = new ERVResponsiveCommon();

			self.changeView = function($trigger, view) {
				var $product = $trigger.parents('.product.booking');
				var $allViewContainers = $product.find('[data-js=view-container]');

				$allViewContainers.addClass('hide');

				var $allWantedContainers= $product.find('[data-view='+view+']');

				$allWantedContainers.removeClass('hide');

				$product.attr('data-step', view);
			}

			self.updatePriceAfterAddonChange = function ($input, parentSelector) {
				var $product = $input.parents(parentSelector);

				var $currentAddonsView = $product.find('[data-js="annual-addons"]:not(.hide), [data-js="tripbytrip-addons"]:not(.hide)'),
				priceAddonsAndCancellation = 0,
				currentBasePrice = Number($currentAddonsView.data('baseprice'));

				priceAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($currentAddonsView);

				var currentTotalPrice = priceAddonsAndCancellation + currentBasePrice;

				self.priceHelper.updateTotalPrice($product, $input, currentTotalPrice);
			};

			self.syncSelectedAddonsWithView = function($input) {
				var $selectedAddonsList = $input.parents('.dropdown').find('[data-js="selected-addons"]');

				if ($input.is(':checked')) {
					var $alreadyExists = $selectedAddonsList.find('li[data-id="' + $input.attr('value') + '"]');

					if ($alreadyExists.length > 0) {
						$alreadyExists.find('.description').text($input.parent().text());
					} else {
						var $liToAdd = $('<li data-id="' + $input.attr('value') + '"><span class="description">' + $input.parent().text() + '</span></li>');
						$selectedAddonsList.append($liToAdd);
					}
				} else {
					var $addonToBeRemoved = $selectedAddonsList.find('li[data-id="' + $input.attr('value') + '"]');
					$addonToBeRemoved.remove();
				}

				self.common.sortArrayByName($selectedAddonsList, 'li');
			};

			self.syncSelectedCancellationWithView = function ($optionSelected) {
				var $selectedAddonsList = $optionSelected.parents('.dropdown').find('[data-js="selected-addons"]'),
					$clearThese = $selectedAddonsList.find('li[data-type="cancellation"]');

				if ($optionSelected.val() && $optionSelected.val().replace('\u2212', '\u002D') !== '-1') {
					$clearThese.remove();

					var $liToAdd = $('<li data-type="cancellation" data-id="' + $optionSelected.val() + '"><span class="description">' + $optionSelected.text() + '</span></li>');
					$selectedAddonsList.append($liToAdd);
				} else {
					$clearThese.remove();
				}
			};

			self.toggleExcessContainer = function ($element, showExcess, parentSelector) {
				var $product = $element.parents(parentSelector),
					$excessContainer = $product.find('.excess-container');

				if (showExcess) {
					$excessContainer.removeClass('hide');
					self.common.forms.disableFormElementsInContainer($excessContainer, false);
				} else {
					$excessContainer.addClass('hide');
					self.common.forms.disableFormElementsInContainer($excessContainer, true);
				}
			}

			self.syncExcessBetweenNeeds = function($container, parentSelector) {
				var $medicalInput = $container.find('input[data-ismedical="true"]:not(:disabled)'),
					medicalExists = $medicalInput.length,
					showExcess = medicalExists && $medicalInput.is(':checked');

				self.toggleExcessContainer($container, showExcess, parentSelector);
			};
		};

		ProductHelper.prototype.updateName = function ($currentProduct, name, isAdded) {
			var $nameContainer = $currentProduct.find('[data-oldproductname]'),
				oldName = $nameContainer.data('oldproductname'),
				changedName;

			if (isAdded) {
				changedName = name;
			} else {
				changedName = oldName;
			}

			$nameContainer.data('oldprice', changedName);
			$nameContainer.text(changedName);
		};

		ProductHelper.prototype.updateAfterAnnual = function ($currentProduct, $input) {
			var self = this;
			if(!$input.prop('checked')){
				return;
			}

			var $containerTripByTripDetails = $currentProduct.find('[data-js=tripbytrip-addons]'),
				$containerAnnualDetails = $currentProduct.find('[data-js=annual-addons]'),
				$excessTrigger = $currentProduct.find('[data-js=excess-trigger]'),
				$tooltipSubtitle = $currentProduct.find('h3.subtitle .tooltip'),
				subtitle = $input.data('subtitle');
			
			var tooltip;

			var priceAnnualAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($containerAnnualDetails),
				priceTripByTripAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($containerTripByTripDetails),
				basePriceAnnual = $input.parents('.insurance-type').find('[data-js="annual"]').data('baseprice'),
				basePriceTripByTrip = $input.parents('.insurance-type').find('[data-js="tripbytrip"]').data('baseprice'),
				priceAnnual = basePriceAnnual,
				priceTripByTrip = basePriceTripByTrip;

			var priceDiff = 0;

			self.common.forms.disableFormElementsInContainer($containerTripByTripDetails, true);
			self.common.forms.disableFormElementsInContainer($containerAnnualDetails, true);

			if ($input.attr('data-js') === 'annual') {
				if ($excessTrigger.length === 1) {
					$excessTrigger.data('includedexcessprice', $excessTrigger.data('annualexcessprice'));
				}
				$containerAnnualDetails.removeClass('hide');
				$containerTripByTripDetails.addClass('hide');
				self.common.forms.disableFormElementsInContainer($containerAnnualDetails.find('[data-js="needs"]:not(.hide)'), false);
				priceAnnualAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($containerAnnualDetails);
				tooltip = $tooltipSubtitle.data('annualtooltip');
			} else {
				if ($excessTrigger.length === 1) {
					$excessTrigger.data('includedexcessprice', $excessTrigger.data('tripbytripexcessprice'));
				}
				$containerAnnualDetails.addClass('hide');
				$containerTripByTripDetails.removeClass('hide');
				self.common.forms.disableFormElementsInContainer($containerTripByTripDetails.find('[data-js="needs"]:not(.hide)'), false);
				priceTripByTripAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($containerTripByTripDetails);
				tooltip = $tooltipSubtitle.data('tbttooltip');
			}

			// check if we should toggle TC, do it only if there are any
			var $annualDocuments = $currentProduct.find('.documents .annual-tc');
			if ($annualDocuments.length) {
				$annualDocuments.toggleClass('hide', $input.attr('data-js') !== 'annual');
				$currentProduct.find('.documents .common-tc').toggleClass('hide', $input.attr('data-js') === 'annual');
			}

			// toggle possible add-ons
			$currentProduct.find('[data-js="possible-addons"]').toggleClass('hide');
			priceAnnual += priceAnnualAddonsAndCancellation;
			priceTripByTrip += priceTripByTripAddonsAndCancellation;

			var isPositive = ($input.attr('data-js') === 'annual' && priceAnnual > priceTripByTrip) || ($input.attr('data-js') === 'tripbytrip' && priceTripByTrip > priceAnnual);

			if (priceTripByTrip > priceAnnual) {
				priceDiff = priceTripByTrip - priceAnnual;
			} else {
				priceDiff = priceAnnual - priceTripByTrip;
			}

			self.priceHelper.updatePrice($currentProduct, $input, priceDiff, isPositive, true);

			var $subtitle = $currentProduct.find('.subtitle');
			$subtitle.find('span').first().text(subtitle);
			$subtitle.find('.tooltip').first().attr('title', tooltip);
			$subtitle.removeClass('hide');
		}

		ProductHelper.prototype.updateAfterNeed = function ($input) {
			var self = this;

			if ($input.is(':checked')) {
				var $currentProduct = $input.parents('.product.booking'),
					$currentAddonsView = $currentProduct
						.find('[data-js="annual-addons"]:not(.hide), [data-js="tripbytrip-addons"]:not(.hide)'),
					$currentSameView = $currentAddonsView.find('.same'),
					$currentIndividualView = $currentAddonsView.find('.individual'),
					$form = $input.parents('form'),
					priceAddonsAndCancellation = 0,
					currentBasePrice = $currentAddonsView.data('baseprice');

				if ($input.attr('data-js') === 'need1') {
					$currentSameView.removeClass('hide');
					$currentIndividualView.addClass('hide');

					self.common.forms.disableFormElementsInContainer($currentSameView, false);
					self.common.forms.disableFormElementsInContainer($currentIndividualView, true);

					$form.attr('action', $form.data('same'));

					if (self.common.framework.checks.isSe())
					{
						self.syncExcessBetweenNeeds($currentSameView, '.product.booking');
					}
				} else {
					$currentSameView.addClass('hide');
					$currentIndividualView.removeClass('hide');

					self.common.forms.disableFormElementsInContainer($currentSameView, true);
					self.common.forms.disableFormElementsInContainer($currentIndividualView, false);

					$form.attr('action', $form.data('individual'));

					if (self.common.framework.checks.isSe())
					{
						self.syncExcessBetweenNeeds($currentIndividualView, '.product.booking');
					}
				}

				priceAddonsAndCancellation = self.priceHelper.calculateTotalPriceInContainer($currentAddonsView);

				var currentTotalPrice = priceAddonsAndCancellation + currentBasePrice;
				self.priceHelper.updateTotalPrice($currentProduct, $input, currentTotalPrice);
			}
		}

		ProductHelper.prototype.updateAfterExcess = function ($container, $excessTrigger) {
			var $inputsToUpdate = $container.find('[data-addon-excess-price]'),
				self = this;

			$inputsToUpdate.each(function() {
				var $input = $(this),
					excessPrice = $input.data('addon-excess-price'),
					$label = $input.siblings('label');

				var $priceSpan = $label.find('[data-currentprice]'),
					currentPrice = $priceSpan.data('currentprice'),
					newPrice = 0;

				if ($excessTrigger.is(':checked')) {
					newPrice = currentPrice - excessPrice;
				}
				else {
					newPrice = currentPrice + excessPrice;
				}

				$priceSpan.text(self.priceHelper.formatPrice(newPrice, false));
				$priceSpan.data('currentprice', newPrice);
				
				if ($input.parents('.individual').length > 0) {
					self.syncSelectedAddonsWithView($input);
				}
			});
		};

		ProductHelper.prototype.productEventHandlers = function ($allProducts, parentSelector) {
			var self = this;

			$allProducts.on('change', '.needs .form-element input[type=radio]', function () {
				var $input = $(this);

				self.updateAfterNeed($input);
			});
			
			$allProducts.on('change', '.insurance-type.field .form-element input[type=radio]', function () {

				var $input = $(this),
					$product = $input.parents(parentSelector);

				$product.find('.insurance-type .type').removeClass('active');

				self.updateAfterAnnual($product, $input);
			});
			
			$allProducts.on('change', '.add-ons .form-element input[type=checkbox], .individual .persons .form-element input[type=checkbox]', function () {
				var $checkbox = $(this);
				var showExcess = self.bookingRules.syncMedicalAndExcess($checkbox);

				if ($checkbox.parents('.individual').length > 0) {
					self.syncSelectedAddonsWithView($checkbox);

					// only for SE
					var $checkedMedicalInputs = $checkbox.parents('.individual').find('input[data-ismedical="true"]').filter(function () {
						return !this.disabled && this.checked;
					});

					if ($checkedMedicalInputs.length > 0) {
						showExcess = true;
					}
				}

				self.toggleExcessContainer($checkbox, showExcess, parentSelector);

				self.updatePriceAfterAddonChange($checkbox, parentSelector);
			});

			$allProducts.on('click', '.add-ons .form-element label.readonly, .individual .persons .form-element label.readonly', function (e) {
				e.preventDefault();
				e.stopPropagation();
			});

			$allProducts.on('change', '[data-js="excess-trigger"]', function () {
				var $this = $(this),
					$product = $this.parents(parentSelector);

				$product.find('[name$="].Excess"], [name="Excess"]').val($this.is(':checked'));

				var $container = $this.parents('[data-view="step2"]');
				self.updateAfterExcess($container, $this);
				
				var addOnExcessPriceInContainer = self.priceHelper.calculateAddOnExcessTotalPriceInContainer($container);

				var isPositive = !$this.is(':checked');

				self.priceHelper.updatePrice($product, $this, addOnExcessPriceInContainer, isPositive, true);
			});

			$allProducts.on('change', '.cancellation select', function () {
				var $optionSelected = $('option:selected', this),
					$select = $(this),
					$product = $optionSelected.parents(parentSelector),
					$info = $select.parent().find('small');

				self.priceHelper.updatePriceCancellation($product, $optionSelected, $optionSelected.data('price'), self.previouslySelectedCancellationPrice);

				$select.data('priceselected', $optionSelected.data('price'));
				$select.find('option[selected="selected"]').removeAttr('selected');
				if ($info.length) {
					$info.toggleClass('hide', $select.val() == '-1')
				}
				$optionSelected.attr('selected', 'selected');
				$select.blur();
				self.syncSelectedCancellationWithView($optionSelected);
			});

			$allProducts.on('focus', '.cancellation select', function () {
				var $selected = $('option:selected', this);
				self.previouslySelectedCancellationPrice = $selected.data('price');
			});

			$allProducts.on('click', '[data-js=nexttrigger]', function (e) {
				e.preventDefault();

				var $this = $(this),
					$currentProduct = $this.parents('.product');

				self.changeView($this, 'step2');

				var $needs = $currentProduct.find('.needs');
				var $heading = $needs.length > 0 ? $needs : $currentProduct.find('[data-view="step2"] .heading').first();
				if (self.responsiveCommon.isDeviceSize('small') && !self.common.framework.checks.isElementInViewport($heading, $('header').height())) {
					$.scrollTo($heading, 200, { offset: -$('header').height() * 2 });
				}

				self.updateAfterNeed($this.parents('.product.booking').find('.needs input[type=radio]:checked'));
			});

			$allProducts.on('click', '[data-js=backtrigger]', function (e) {
				e.preventDefault();

				var $this = $(this),
					$currentProduct = $this.parents('.product');

				self.changeView($this, 'step1');

				var $heading = $currentProduct.find('[data-view="step1"] .heading').first();
				if (self.responsiveCommon.isDeviceSize('small') && !self.common.framework.checks.isElementInViewport($heading, $('header').height())) {
					$.scrollTo($heading, 200, { offset: -$('header').height() * 2 });
				}
			});

			$allProducts.on('click', '.last .show-all', function (e) {
				var $this = $(this),
					$parent = $this.parents('.includes');

				$parent.find('.expand-collapse[data-visible]').each(function () {
					$(this).attr('data-visible', $this.attr('data-state') !== 'more');
				});
			});
			
			self.common.triggers.initTriggers('.documents');
		};

		return ProductHelper;
});